import React, { useState } from "react";
import { Heart, Loader2, CheckCircle2 } from "lucide-react";
import api from "../api";
import { toast } from "../hooks/use-toast";
import { VideoRecorder } from "./VideoRecorder";

export const ThankYouReaction = ({ code, buyerName, businessName }) => {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [consent, setConsent] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      await api.post(`/voucher/${code}/reaction`, { video_url: url, feature_consent: consent });
      setSent(true);
    } catch (err) {
      toast({ title: "Could not send", description: err?.response?.data?.detail || "Try again", variant: "destructive" });
    } finally { setSending(false); }
  };

  if (sent) return (
    <div className="mb-6 rounded-2xl bg-[#dcfce7] text-[#166534] p-4 flex items-center gap-2 font-medium" data-testid="reaction-sent">
      <CheckCircle2 size={18} /> Your thank-you video is on its way to {buyerName || "the sender"}!
    </div>
  );
  return (
    <div className="mb-6 rounded-2xl bg-white p-5 shadow-[0_8px_24px_rgba(20,30,55,0.06)]" data-testid="thank-you-reaction">
      {!open ? (
        <button onClick={() => setOpen(true)} data-testid="reaction-open-btn" className="w-full flex items-center justify-between gap-3 text-left">
          <span>
            <span className="font-semibold text-[#16243b] flex items-center gap-1.5"><Heart size={16} className="text-rose-500" /> Say thank you{buyerName ? ` to ${buyerName}` : ""}</span>
            <span className="text-sm text-[#8a97a8]">Record a quick video reaction (up to 30 seconds).</span>
          </span>
          <span className="gp-btn-teal rounded-full px-4 py-2 text-sm font-medium shrink-0">Record</span>
        </button>
      ) : (
        <>
          <VideoRecorder uploadPath={`/voucher/${code}/reaction-upload`} value={url} onChange={setUrl} label="Thank-you video (up to 30s)" />
          <p className="text-xs text-[#8a97a8] mt-2">You can redo it as many times as you like. Once sent, it can't be changed.</p>
          <label className="flex items-start gap-2 text-sm text-[#16243b] mt-3">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} data-testid="reaction-consent" className="mt-0.5" />
            Happy for {businessName || "the business"} to feature this video on their website
          </label>
          <button onClick={send} disabled={!url || sending} data-testid="reaction-send-btn"
            className="gp-btn-teal w-full rounded-xl py-3 font-medium mt-3 flex items-center justify-center gap-2 disabled:opacity-50">
            {sending ? <Loader2 size={16} className="animate-spin" /> : <Heart size={16} />} Send thank-you
          </button>
        </>
      )}
    </div>
  );
};
